import StandardQueryTable from "@/components/StandardQueryTable";
import DictionaryCreator from "@/components/dictionaries/DictionaryCreator";
import DictionaryEditor from "@/components/dictionaries/DictionaryEditor";
import { PATH_DICTS_PROVINCES } from "@/constants";
import { createDictionaryLabels } from "@/containers/dictionaries/createDictionaryLabels";
import { Module } from "@/constants";
import { getDictionaryLabels } from "@/containers/dictionaries/getDictionaryLabels";
import { DictionaryConfig } from "@/containers/dictionaries/types";
import { province, writeProvince } from "@/schemas/province";
import { ProvinceService } from "@/services/province";
import { ReadProvince, WriteProvince } from "@/types/province";
import { MapPinned } from "lucide-react";

const id = Module.Provinces;
const path = PATH_DICTS_PROVINCES;
const ns = "provinces";

const config: DictionaryConfig<ReadProvince, WriteProvince> = {
  id,
  ns,
  service: ProvinceService,
  path,
  labels: createDictionaryLabels(ns),
  getLabels: getDictionaryLabels,
  schema: writeProvince,
  defaultValues: {
    name: "",
    nfz_code: "",
    nfz_description: "",
  },
  Icon: MapPinned,
  List: () => (
    <StandardQueryTable<ReadProvince>
      schema={province}
      name={ns}
      fetchList={ProvinceService.getList}
      pathBuilder={(row) => `${path}/${row.id}`}
      actions={[]}
      tableFeatures={{
        exportSettings: { moduleName: Module.Provinces },
      }}
    />
  ),
  Creator: DictionaryCreator,
  Editor: DictionaryEditor,
};

export default config;
